document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".wpcf7-form-control").forEach((input) => {
        const label = input.closest("label");
        if (!label) return;

        const setFloatingLabelClass = () => {
            const hasValue = input.value?.trim() !== "";
            const isFocused = document.activeElement === input;

            label.classList.toggle("active", hasValue || isFocused);
        };

        const handleBlur = () => {
            if (!label) return;
            const isValid = input.getAttribute("aria-invalid") === "false";
            const isFilledAndValid = input.value?.trim() && isValid;

            !input.value.trim() && label.classList.remove("active");
            if (input.classList.contains("footer__newsletter-input")) {
                label.classList.toggle("footer__newsletter-input--filled", isFilledAndValid);
            } else {
                label.classList.toggle("filled", isFilledAndValid);
            }
        };

        input.addEventListener("focus", setFloatingLabelClass);
        input.addEventListener("input", setFloatingLabelClass);
        input.addEventListener("blur", handleBlur);

        setFloatingLabelClass();
    });
});
